import { render, staticRenderFns } from "./StackSubNav.vue?vue&type=template&id=45254b9a&scoped=true&"
import script from "./StackSubNav.vue?vue&type=script&lang=js&"
export * from "./StackSubNav.vue?vue&type=script&lang=js&"
import style0 from "./StackSubNav.vue?vue&type=style&index=0&id=45254b9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45254b9a",
  null
  
)

export default component.exports